import { render, staticRenderFns } from "./RedactarContratos.vue?vue&type=template&id=3b7648e4&scoped=true"
import script from "./RedactarContratos.vue?vue&type=script&lang=js"
export * from "./RedactarContratos.vue?vue&type=script&lang=js"
import style0 from "./RedactarContratos.vue?vue&type=style&index=0&id=3b7648e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7648e4",
  null
  
)

export default component.exports